<template>
  <div id="certificate-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-content--info">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("title") }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-html="$t('body')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificateModal"
};
</script>

<i18n>
{
  "cs": {
    "title": "Doživotní certifikace v ceně",
    "body": "V ceně doživotní <a target='_blank' href='https://www.scrum.cz/peoplecertscrum-vs-scrumalliance-vs-scrumorg'>certifikace PeopleCert</a> (5 900 Kč)."
  },
  "en": {
    "title": "Live on-line courses",
    "body": "V ceně doživotní <a target='_blank' href='https://www.scrum.cz/peoplecertscrum-vs-scrumalliance-vs-scrumorg'>certifikace PeopleCert</a> (5 900 Kč)."
  }
}
</i18n>
